import { render, staticRenderFns } from "./ModalKitsAndDomains.vue?vue&type=template&id=3bf1378c"
import script from "./ModalKitsAndDomains.vue?vue&type=script&lang=js"
export * from "./ModalKitsAndDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf1378c')) {
      api.createRecord('3bf1378c', component.options)
    } else {
      api.reload('3bf1378c', component.options)
    }
    module.hot.accept("./ModalKitsAndDomains.vue?vue&type=template&id=3bf1378c", function () {
      api.rerender('3bf1378c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/modals/ModalKitsAndDomains.vue"
export default component.exports